import { CountrysideBuildersCallback } from '@cian/frontend-builders-callback-widget';
import { useApplicationContext } from '../../utils/applicationContext';
import { useSelector } from 'react-redux';
import { selectBuilderId } from '../../selectors/builder';
import { selectUserName, selectUserPhone } from '../../selectors/user';
import * as React from 'react';
import { ECallbackWidgetPlacement } from '../../types/callbackWidget';
import { useCallbackButtonProps, useCallbackAnalytics } from '../../hooks';
import { selectLocation } from '../../selectors/location';
import { selectIsCallbackButtonEnabled } from '../../selectors/callbackButton';

interface ICallbackButtonContainerProps {
  placement: ECallbackWidgetPlacement;
}

export const CallbackButtonContainer: React.FC<ICallbackButtonContainerProps> = ({ placement }) => {
  const { httpApi, logger } = useApplicationContext();
  const builderId = useSelector(selectBuilderId);
  const userPhone = useSelector(selectUserPhone);
  const userName = useSelector(selectUserName);
  const region = useSelector(selectLocation);

  const buttonProps = useCallbackButtonProps(placement);
  const { trackCallbackModalOpen, trackCallbackApplicationSubmit } = useCallbackAnalytics(placement);

  const isCallbackFormEnabled = useSelector(selectIsCallbackButtonEnabled);

  /* istanbul ignore next */
  if (!isCallbackFormEnabled) {
    return null;
  }

  return (
    <CountrysideBuildersCallback
      httpApi={httpApi}
      logger={logger}
      companyId={builderId}
      phone={userPhone}
      userName={userName}
      regionId={region?.id}
      buttonProps={buttonProps}
      onOpen={trackCallbackModalOpen}
      onSubmit={trackCallbackApplicationSubmit}
    />
  );
};
